module.exports = __webpack_public_path__ + "img/93985.8b3362b5.svg";